// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.IhEra4 {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
  background-color: var(--background-alt);
}

.KdGWyG {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-3);
}

.tMpJFx {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-2);
  color: var(--status-error);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
}

/* Responsive */
@media (max-width: var(--grid-breakpoint-xs)) {
  .KdGWyG {
    padding: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/ChargesPDF/ChargesPDF.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Main container */\n.main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 100vh;\n  background-color: var(--background-alt);\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-3);\n}\n\n.error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-2);\n  color: var(--status-error);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n}\n\n/* Responsive */\n@media (max-width: var(--grid-breakpoint-xs)) {\n  .container {\n    padding: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `IhEra4`,
	"container": `KdGWyG`,
	"error": `tMpJFx`
};
module.exports = ___CSS_LOADER_EXPORT___;
